import { render, staticRenderFns } from "./QueenCard.vue?vue&type=template&id=795c2817&scoped=true"
import script from "./QueenCard.vue?vue&type=script&lang=js"
export * from "./QueenCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795c2817",
  null
  
)

export default component.exports